import { BulkEditRequestBody } from "@syla/shared/types/requests/BulkEditRequest";
import { BulkEditResponse } from "@syla/shared/types/responses/BulkEditResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export type BulkEditRequestProps = {
  accountId: string;
} & BulkEditRequestBody;

export async function bulkEdit({
  accountId,
  ...body
}: BulkEditRequestProps): Promise<BulkEditResponse> {
  try {
    const response = await axios.post<BulkEditResponse>(
      `/accounts/${accountId}/transactions/bulk-edit`,
      body,
    );

    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
